import React, { useContext, useRef, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Form, Typography, Input, Select, theme, Spin, Col, Flex } from 'antd';
import _ from 'lodash';

import { MessageContext } from '../../../layouts/NavigationLayout';

//Constants
import CommonEnum from '../../../constants/CommonEnum';

//Helpers
import GeneralHelper from '../../../helpers/general';

//Compnents
import Confirmation from '../../../components/Confirmation';
import ButtonGroupComponent from './ButtonGroupComponent';

const { Title, Text } = Typography;
const { Item } = Form;
const { useToken } = theme;

const InformationOfRefereesView = (props) => {
	const [nextDisabled, setNextDisabled] = useState(true);
	const [draftDisabled, setDraftDisabled] = useState(true);
	const [isNext, setIsNext] = useState(false);
	const [warningPhoneFirst, setWarningPhoneFirst] = useState(false);
	const [warningPhoneSec, setWarningPhoneSec] = useState(false);
	const [secondRefRequired, setSecondRefRequired] = useState(false);
	const [isInvalidEmail, setIsnInvalidEmail] = useState(false);
	const [isInitialLoad, setIsInitialLoad] = useState(true);
	const [confirmation, setConfirmation] = useState(false);

	const history = useHistory();
	const formRef = useRef(null);
	const { token } = useToken();
	const messageApi = useContext(MessageContext);

	const query = GeneralHelper.getParamsFromUrl();

	const { colorPrimary } = token;

	const { refereeInfoPageProps, getApplication, getRefereeInfo, onRefereeInfoSubmit, resetRefereeInfoPage,
		resetRefereeInfoMeta, reviewAndSubmissionPageProps, setHasUnsavedChanges } = props;
	const { refereeInfo , loading, loadingSubmit, meta } = refereeInfoPageProps || {};
	const secondRefFieldStyle = secondRefRequired ? {} : { padding: 0.5 };
	const { application } = reviewAndSubmissionPageProps;
	const currentStep = _.get(application, 'current_step');

	useEffect(() => {
		query.application_id && getRefereeInfo(query.application_id);

		return() => {
			resetRefereeInfoPage();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if(!_.isEmpty(refereeInfo)){
			const existingReferee = (
				query.application_id &&
				refereeInfo.find(
					referee => referee.type === 'second' &&
					referee.application_id === query.application_id
				)
			);
			existingReferee && setSecondRefRequired(true);
		}
		checkFormValues();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refereeInfo]);

	useEffect(() => {
		if(isInitialLoad && secondRefRequired){
			checkFormValues();
		}
		isInitialLoad === false && checkFormValues();
		secondRefRequired === false && clearSecondRefereeValues();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [secondRefRequired]);

	useEffect(() => {
		checkFormValues();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInvalidEmail]);

	useEffect(() => {
		checkFormValues();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInitialLoad]);

	useEffect(() => {
		if(meta){
			if(meta.code === 200){
				setDraftDisabled(true);
				setHasUnsavedChanges(false);
				setWarningPhoneFirst(false);
				setWarningPhoneSec(false);
				setIsInitialLoad(true);
				!isNext && isInitialLoad === false && messageApi.open({
					type: 'success',
					content: `${meta.message}`,
					duration: 2.5
				});
				if (isNext) {
					window.location.href = process.env.NODE_ENV === 'development'
						? `/application?step=6&application_id=${query.application_id}`
						: `/summercamp/app/application?step=6&application_id=${query.application_id}`;
				}
				!isNext && !nextDisabled && query.application_id && getApplication(query.application_id);
			} else {
				messageApi.open({
					type: 'error',
					content: `${meta.message}`,
					duration: 2.5
				});
			}
		}
		return () => {
			resetRefereeInfoMeta();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	//Start of Functions

	const getInitialValues = () => {
		const initialValues = {};

		if (_.isEmpty(refereeInfo)) {
		  return initialValues;
		}

		for (const referee of refereeInfo) {
		  const {
				type,
				salutation,
				last_name,
				first_name,
				position,
				department,
				organization,
				relationship,
				email,
				phone
		  } = referee;

		  if (type === 'first') {
				initialValues['salutation_1'] = salutation;
				initialValues['last_name_1'] = last_name;
				initialValues['first_name_1'] = first_name;
				initialValues['position_1'] = position;
				initialValues['department_1'] = department;
				initialValues['organization_1'] = organization;
				initialValues['relationship_1'] = relationship;
				initialValues['email_1'] = email;
				initialValues['phone_1'] = phone;
		  } else if (type === 'second') {
				initialValues['salutation_2'] = salutation;
				initialValues['last_name_2'] = last_name;
				initialValues['first_name_2'] = first_name;
				initialValues['position_2'] = position;
				initialValues['department_2'] = department;
				initialValues['organization_2'] = organization;
				initialValues['relationship_2'] = relationship;
				initialValues['email_2'] = email;
				initialValues['phone_2'] = phone;
		  }
		}

		return initialValues;
	  };

	const onNext = () => {
		setIsNext(true);
	};

	const checkFormValues = () => {
		if(formRef.current){
			if(secondRefRequired){
				if(
					formRef.current.getFieldValue('salutation_1') &&
					formRef.current.getFieldValue('last_name_1') &&
					formRef.current.getFieldValue('first_name_1') &&
					formRef.current.getFieldValue('position_1') &&
					formRef.current.getFieldValue('department_1') &&
					formRef.current.getFieldValue('organization_1') &&
					formRef.current.getFieldValue('relationship_1') &&
					formRef.current.getFieldValue('email_1') &&
					(formRef.current.getFieldValue('phone_1') || !formRef.current.getFieldValue('phone_1')) &&
					formRef.current.getFieldValue('salutation_2') &&
					formRef.current.getFieldValue('last_name_2') &&
					formRef.current.getFieldValue('first_name_2') &&
					formRef.current.getFieldValue('position_2') &&
					formRef.current.getFieldValue('department_2') &&
					formRef.current.getFieldValue('organization_2') &&
					formRef.current.getFieldValue('relationship_2') &&
					formRef.current.getFieldValue('email_2') &&
					(formRef.current.getFieldValue('phone_2') || !formRef.current.getFieldValue('phone_2')) &&
					isInvalidEmail === false
				) {
					setNextDisabled(false);
				} else {
					setNextDisabled(true);
				}
			} else {
				if(
					formRef.current.getFieldValue('salutation_1') &&
					formRef.current.getFieldValue('last_name_1') &&
					formRef.current.getFieldValue('first_name_1') &&
					formRef.current.getFieldValue('position_1') &&
					formRef.current.getFieldValue('department_1') &&
					formRef.current.getFieldValue('organization_1') &&
					formRef.current.getFieldValue('relationship_1') &&
					formRef.current.getFieldValue('email_1') &&
					(formRef.current.getFieldValue('phone_1') || !formRef.current.getFieldValue('phone_1')) &&
					!formRef.current.getFieldValue('salutation_2') &&
					!formRef.current.getFieldValue('last_name_2') &&
					!formRef.current.getFieldValue('first_name_2') &&
					!formRef.current.getFieldValue('position_2') &&
					!formRef.current.getFieldValue('department_2') &&
					!formRef.current.getFieldValue('organization_2') &&
					!formRef.current.getFieldValue('relationship_2') &&
					!formRef.current.getFieldValue('email_2') &&
					!formRef.current.getFieldValue('phone_2') &&
					isInvalidEmail === false
				) {
					setNextDisabled(false);
				} else {
					setNextDisabled(true);
				}
			}

			//Separate trappings for draftDisabled
			if(
				formRef.current.getFieldValue('salutation_1') ||
				formRef.current.getFieldValue('last_name_1') ||
				formRef.current.getFieldValue('first_name_1') ||
				formRef.current.getFieldValue('position_1') ||
				formRef.current.getFieldValue('department_1') ||
				formRef.current.getFieldValue('organization_1') ||
				formRef.current.getFieldValue('relationship_1') ||
				formRef.current.getFieldValue('email_1') ||
				formRef.current.getFieldValue('phone_1') ||
				formRef.current.getFieldValue('salutation_2') ||
				formRef.current.getFieldValue('last_name_2') ||
				formRef.current.getFieldValue('first_name_2') ||
				formRef.current.getFieldValue('position_2') ||
				formRef.current.getFieldValue('department_2') ||
				formRef.current.getFieldValue('organization_2') ||
				formRef.current.getFieldValue('relationship_2') ||
				formRef.current.getFieldValue('email_2') ||
				formRef.current.getFieldValue('phone_2') &&
				isInvalidEmail === false
			) {
				if (isInitialLoad) {
					setDraftDisabled(true);
					setHasUnsavedChanges(false);
				} else {
					setDraftDisabled(false);
					setHasUnsavedChanges(true);
				}
			} else {
				setDraftDisabled(true);
				setHasUnsavedChanges(false);
			}
		}
	};

	const checkSecondRefereeValues = () => {
		if(
			formRef.current.getFieldValue('salutation_2') ||
			formRef.current.getFieldValue('last_name_2') ||
			formRef.current.getFieldValue('first_name_2') ||
			formRef.current.getFieldValue('position_2') ||
			formRef.current.getFieldValue('department_2') ||
			formRef.current.getFieldValue('organization_2') ||
			formRef.current.getFieldValue('relationship_2') ||
			formRef.current.getFieldValue('email_2') ||
			formRef.current.getFieldValue('phone_2')
		) {
			setSecondRefRequired(true);
		} else {
			setSecondRefRequired(false);
		}
	};

	const handleSubmit = (values) => {
		const fields = [];
		const valuesLength = secondRefRequired ? 2 : 1;
		for (let i = 1; i <= valuesLength; i++) {
			const type = i === 1 ? 'first' : 'second';
			const field = {
					  application_id: query.application_id,
					  save_method: nextDisabled ? 'draft_save' : 'final_save',
					  type,
					  salutation: values[`salutation_${i}`],
					  last_name: values[`last_name_${i}`],
					  first_name: values[`first_name_${i}`],
					  position: values[`position_${i}`],
					  department: values[`department_${i}`],
					  organization: values[`organization_${i}`],
					  relationship: values[`relationship_${i}`],
					  email: values[`email_${i}`],
					  phone: values[`phone_${i}`]
				  };
			if(!_.isEmpty(refereeInfo)){
				const existingReferee = (
					query.application_id &&
					refereeInfo.find(
						referee => referee.type === type &&
						referee.application_id === query.application_id
					)
				);
				if(existingReferee){
					field.id = existingReferee._id;
					field.updated_at = existingReferee.updated_at;
				}
			}
			fields.push(field);
		}
		!_.isEmpty(fields) && onRefereeInfoSubmit(fields);
	};

	const validateEmail = (_, value) => {
		if (value && !/^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i.test(value)) {
			setIsnInvalidEmail(true);
		  return Promise.reject('Please enter a valid email address');
		}
		setIsnInvalidEmail(false);
		return Promise.resolve();
	};

	const onPhoneNumberPaste= (event, type) => {
		const pastedText = event.clipboardData.getData('text');
		if (!/[0-9\s()+-]/.test(pastedText)) {
			event.preventDefault();
			if(type === 'first') {
				setWarningPhoneFirst(true);
				setWarningPhoneSec(false);
			}
			if(type === 'second'){
				setWarningPhoneSec(true);
				setWarningPhoneFirst(false);
			}
		} else {
			setWarningPhoneFirst(false);
			setWarningPhoneSec(false);
			setIsInitialLoad(false);
		}
	};

	const clearSecondRefereeValues = () => {
		formRef.current.setFieldsValue({
			salutation_2: null,
			last_name_2: null,
			first_name_2: null,
			position_2: null,
			department_2: null,
			organization_2: null,
			relationship_2: null,
			email_2: null,
			phone_2: null
		});
	};
	//End of Functions

	if(loading){
		return (
			<div
				style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
			>
				<Spin/>
			</div>
		);
	}

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
			<Form
				ref={formRef}
				layout="vertical"
				initialValues={getInitialValues()}
				onFinish={handleSubmit}
			>
				<Row style={{ marginBottom: 20 }}>
					<Col>
						<Title
							level={2}
							style={{ color: colorPrimary }}
						>Step 6</Title>
						<Row>
							<Text style={{ fontSize: 20, fontWeight: 510 }}>Information of Referees</Text>
						</Row>
						<Row>
							<Text>System-generated invitation emails will be sent to referees after the application is submitted.
								At least <Text underline>one</Text> letter of recommendation from your home institution must be provided.
							</Text>
						</Row>
						<Row>
							<Text strong>Please obtain consent from the referee(s) before providing their information below.</Text>
						</Row>
					</Col>
				</Row>
				<Row justify="space-between">
					<Col
						xl={11}
						lg={11}
						md={24}
						sm={24}
						xs={24}
					>
						<Item>
							<Text style={{ fontSize: 20, fontWeight: 510 }}>The First Referee</Text>
						</Item>
						<Item
							label="Salutation"
							name="salutation_1"
							required
						>
							<Select
								placeholder="Select Salutation"
								options={CommonEnum.salutation}
								onChange={() => {
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onClear={() => {
									setIsInitialLoad(false);
									checkFormValues();
								}}
							/>
						</Item>
						<Item
							label="Family Name / Last Name"
							name="last_name_1"
							required
						>
							<Input
								placeholder="Enter Last Name"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ last_name_1: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									GeneralHelper.handleCapitalization(formRef, 'last_name_1');
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Given Name / First Name"
							name="first_name_1"
							required
						>
							<Input
								placeholder="Enter First Name"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ first_name_1: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Position"
							name="position_1"
							required
						>
							<Input
								placeholder="Position"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ position_1: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Department / Unit"
							name="department_1"
							required
						>
							<Input
								placeholder="Enter Department / Unit"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ department_1: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Institution"
							name="organization_1"
							required
						>
							<Input
								placeholder="Enter Institution"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ organization_1: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Relationship with Applicant"
							name="relationship_1"
							required
						>
							<Input
								placeholder="Enter Relationship"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ relationship_1: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Institutional Email"
							name="email_1"
							required
							rules={[
								{ validator: validateEmail }
							]}
						>
							<Input
								placeholder="Enter Institutional Email"
								onChange={() => {
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Contact No. (Optional)"
							name="phone_1"
						>
							<Input
								placeholder="Enter Contact No."
								onChange={() => {
									setIsInitialLoad(false);
									checkFormValues();
									setWarningPhoneFirst(false);
								}}
								onKeyPress={(event) => {
									if (!/[0-9\s()+-]/.test(event.key)) {
										event.preventDefault();
										setWarningPhoneFirst(true);
									} else {
										setWarningPhoneFirst(false);
										setIsInitialLoad(false);
									}
								}}
								onPaste={(e) => onPhoneNumberPaste(e, 'first')}
								autoComplete="nope"
							/>
						</Item>
						{warningPhoneFirst &&
						<Row style={{ marginTop: -20, marginBottom: 20  }}>
							<Text type="warning">
								Invalid characters. Only digits, dashes, spaces, parentheses, and plus symbols are allowed.
							</Text>
						</Row>
						}
					</Col>
					<Col
						xl={11}
						lg={11}
						md={24}
						sm={24}
						xs={24}
					>
						<Item>
							<Text style={{ fontSize: 20, fontWeight: 510 }}>The Second Referee</Text>
						</Item>

						<Item
							label="Salutation"
							name="salutation_2"
							required={secondRefRequired}
							style={secondRefFieldStyle}
						>
							<Select
								placeholder="Select Salutation"
								options={CommonEnum.salutation}
								onChange={() => {
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onClear={() => {
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
								}}
								allowClear
							/>
						</Item>
						<Item
							label="Family Name / Last Name"
							name="last_name_2"
							required={secondRefRequired}
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Enter Last Name"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ last_name_2: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									GeneralHelper.handleCapitalization(formRef, 'last_name_2');
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Given Name / First Name"
							name="first_name_2"
							required={secondRefRequired}
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Enter First Name"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ first_name_2: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Position"
							name="position_2"
							required={secondRefRequired}
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Position"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ position_2: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Department / Unit"
							name="department_2"
							required={secondRefRequired}
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Enter Department / Unit"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ department_2: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Institution"
							name="organization_2"
							required={secondRefRequired}
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Enter Institution"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ organization_2: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Relationship with Applicant"
							name="relationship_2"
							required={secondRefRequired}
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Enter Relationship"
								onChange={(e) => {
									const inputValue = e.target.value;

									// Check if it contains disallowed characters
									if (GeneralHelper.checkDisallowedCharacters(inputValue)) {
										// Sanitize the input by removing disallowed characters
										const sanitizedValue = GeneralHelper.sanitizeInput(inputValue);

										// Update form with sanitized value
										formRef.current.setFieldsValue({ relationship_2: sanitizedValue });
									}

									// After sanitizing, proceed with your other operations
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								onKeyDown={GeneralHelper.preventDisallowedKeys}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Institutional Email"
							name="email_2"
							required={secondRefRequired}
							rules={[
								{ validator: validateEmail }
							]}
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Enter Institutional Email"
								onChange={() => {
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
									setWarningPhoneSec(false);
								}}
								autoComplete="nope"
							/>
						</Item>
						<Item
							label="Contact No. (Optional)"
							name="phone_2"
							style={secondRefFieldStyle}
						>
							<Input
								placeholder="Enter Contact No."
								onChange={() => {
									setIsInitialLoad(false);
									checkSecondRefereeValues();
									checkFormValues();
									setWarningPhoneFirst(false);
								}}
								onKeyPress={(event) => {
									if (!/[0-9+()-\s]/.test(event.key)) {
										event.preventDefault();
										setWarningPhoneSec(true);
									} else {
										setWarningPhoneSec(false);
										setIsInitialLoad(false);
									}
								}}
								onPaste={(e) => onPhoneNumberPaste(e, 'second')}
								autoComplete="nope"
							/>
						</Item>
						{warningPhoneSec &&
						<Row style={{ marginTop: -20, marginBottom: 20  }}>
							<Text type="warning">
								Invalid characters. Only digits, dashes, spaces, parentheses, and plus symbols are allowed.
							</Text>
						</Row>
						}
					</Col>
				</Row>
				<ButtonGroupComponent
					currentStep={currentStep}
					draftDisabled={draftDisabled}
					saveDisabled={nextDisabled}
					loadingSubmit={loadingSubmit}
					onSave={onNext}
					onPrevious={() => {
						if(!draftDisabled){
							setConfirmation(true);
						} else {
							history.push(`/application?step=4&application_id=${query.application_id}`);
						}
					}}
				/>
				<Confirmation
					loading={loadingSubmit}
					open={confirmation}
					onCancel={() => setConfirmation(false)}
					onOk={() => {
						draftDisabled === false && formRef.current.submit();
						history.push(`/application?step=4&application_id=${query.application_id}`);
					}}
				>
					<Flex
						vertical
						gap={30}
					>
						<Text>
							Save your changes before going back to the previous step?
						</Text>
					</Flex>
				</Confirmation>
			</Form>
		</div>
	);
};

export default InformationOfRefereesView;
